export { default } from './Container';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Container/index.js
// module id = 319
// module chunks = 0